import { Box } from '@fhs-legacy/universal-components';
import Picture from 'components/picture';

export const Wrapper = Box.withConfig({ width: 'full' });

export const Image = Picture.withConfig({ width: '$10', height: '$10' });
